<template>
  <v-sheet
    class="invoice-details"
    :class="classes"
    :color="color"
    v-bind="$attrs"
  >
    <v-row>
      <v-col cols="12" xs="12" md="4">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('EREPORTER.PERIOD') }}:</span
          >
          <span>
            {{ details.period }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" xs="12" md="8">
        <p class="text-body-1 d-flex align-center">
          <span class="text--primary font-weight-bold"
            >{{ $t('EREPORTER.CUSTOMER') }}:</span
          >
          <span class="pl-1">
            {{ customerName }}
          </span>
          <v-spacer></v-spacer>
          <v-btn class="float-right" small icon :to="to">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </p>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" xs="12" md="4">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('EREPORTER.INVOICES.INVOICE_NUMBER') }}:</span
          >
          <span>
            {{ details.invoice_number || '' }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" xs="12" md="8">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('EREPORTER.INVOICES.ITEM') }} {{ $t('ITEM.TYPE') }}:</span
          >
          <span>
            {{ details.type.name || '' }}
          </span>
        </p>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" xs="12" md="4">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('ITEM.CREATED_AT') }}:</span
          >
          <span>
            {{ details.created_at | dateFormat }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" xs="12" md="8">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('PROFILE.EMAIL') }}:</span
          >
          <span>
            {{ customer.invoice_email || '' }}
          </span>
        </p>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" xs="12" md="4">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('ITEM.UPDATED_AT') }}:</span
          >
          <span>
            {{ details.updated_at | dateFormat }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" xs="12" md="8">
        <p class="text-body-1">
          <span class="text--primary font-weight-bold"
            >{{ $t('EREPORTER.INVOICES.SENT_VIA_EMAIL') }}:</span
          >
          <span>
            {{ details.sent_via_email | dateFormat }}
          </span>
        </p>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'InvoiceDetails',

  filters: {
    dateFormat
  },

  props: {
    details: {
      type: Object,
      default: () => ({})
    },

    customer: {
      type: Object,
      default: () => ({})
    },

    color: {
      type: String,
      default: 'grey lighten-4'
    },

    classes: {
      type: String,
      default: ''
    },

    customerRoute: {
      type: String,
      required: true,
      default: 'persons.show'
    },

    customerName: {
      type: String,
      required: true
    }
  },

  computed: {
    to() {
      return {
        name: this.customerRoute,
        params: { id: this.details.customer.id }
      };
    }
  }
};
</script>
